import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import * as layouts from "../../GramLayouts";

import homedata from "../../gramdata/Homepage";
import NavAndFooter from "../Common/NavAndFooterContainer/GramNavAndFooter";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      // backgroundColor: "white",
    },
  },
}));

const GramHome = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {homedata?.data?.map((data, index) => {
        const Layout = layouts[data?.layout];
        return data && <Layout key={index} data={data} />;
      })}
    </div>
  );
};
export default GramHome;
